import { CancellationState } from "@/data/model/Enums";

import { i18n } from "@/portal/Trans";

export class CancellationStateBadge {
    public static renderTo($parent: JQuery, cancellationState: CancellationState) {
        $(this.render(cancellationState)).appendTo($parent);
    }

    public static render(cancellationState: CancellationState) {
        const state = CancellationState[cancellationState];
        return `<span class="cancellation-state-badge">${i18n("enums.CancellationState." + state)}</span>`;
    }
}
